import React from 'react';
import { WithFormikConfig, withFormik, FormikProps } from 'formik';
import { object, string } from 'yup';

import RootContainer from '../../shared/RootContainer';
import PaymentsHeader from '../../shared/PaymentsHeader';
import PaymentDetailsForm from './PaymentDetailsForm';
import { PaymentDetailsValues } from '../helperTypes';

type Values = PaymentDetailsValues;

type OwnProps = {
  initialValues: PaymentDetailsValues;
  onConfirmPaymentDetails: (details: PaymentDetailsValues) => void;
};

type NonFormikProps = OwnProps;
type Props = NonFormikProps & FormikProps<Values>;

const withFormikConfig: WithFormikConfig<NonFormikProps, Values> = {
  mapPropsToValues: ({ initialValues }) =>
    initialValues || {
      patient_first_name: '',
      patient_last_name: '',
      amount_usd: '',
      invoice_number: '',
      notes: '',
    },
  handleSubmit: (values, formikBag) => {
    try {
      formikBag.props.onConfirmPaymentDetails(values);
    } finally {
      formikBag.setSubmitting(false);
    }
  },
  validationSchema: object().shape({
    patient_first_name: string().required('Required'),
    patient_last_name: string().required('Required'),
    amount_usd: string()
      .required('Required')
      .test('valid amount', '', function testValidAmount(value: string) {
        let errorMessage;
        const amount = Number(value);
        if (amount < 0.5) {
          errorMessage = 'Minimum of $0.50';
        } else if (amount > 999999.99) {
          errorMessage = 'Maximum of $999,999.99';
        }
        const isValid = !errorMessage;

        return (
          isValid ||
          this.createError({
            path: 'amount_usd',
            message: errorMessage,
          })
        );
      }),
    invoice_number: string().max(50, 'Exceeded max length').required('Required'),
    notes: string().max(500, 'Exceeded max length'),
  }),
};

const PaymentDetailsStep: React.FC<Props> = () => {
  return (
    <RootContainer>
      <PaymentsHeader />
      <PaymentDetailsForm />
    </RootContainer>
  );
};

export default withFormik(withFormikConfig)(PaymentDetailsStep);
